async function TestSave(testid, configid, testnum, blanknum, topvalue, bottomvalue, position) {

    if (true) {

        let response;

        let params = {
            "@TestID": testid,
            "@ConfigID": configid,
            "@TestNum": testnum,
            "@BlankNum": blanknum,
            "@TopValue": topvalue,
            "@BottomValue": bottomvalue,
            "@Position": position
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "101",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default TestSave;